import { ICheckPublishTermSchema } from '../../../../../repositories/monolith-python/entities/CheckPublishTermSchema';
import {
  EPlacingType,
  IAuctionState,
  ICalltracking,
  IPublishOption,
  IPublishTermsService,
  IRecommendedServicePackage,
} from '../../../../reducers';
import { mapAuctionTerm } from './mapAuctionTerm';
import { mapCalltrackingTerm } from './mapCalltrackingTerm';
import { mapPublishTerm } from './mapPublishTerm';
import { mapServicePackageTerm } from './mapServicePackageTerm';

interface IGetPublishTermsParams {
  service: IPublishTermsService | null;
  servicePackage: IPublishOption | null;
  recommendedPackage: IRecommendedServicePackage | null;
  period: IPublishOption | null;
  placingType: EPlacingType | null;
  auction: IAuctionState;
  isAuctionEnabled: boolean;
  calltracking: ICalltracking;
}

export function getPublishTerms(params: IGetPublishTermsParams): ICheckPublishTermSchema[] {
  const {
    service,
    servicePackage,
    recommendedPackage,
    period,
    placingType,
    auction,
    isAuctionEnabled,
    calltracking,
  } = params;

  const terms: ICheckPublishTermSchema[] = [];

  if (!service) {
    return terms;
  }

  if (placingType === EPlacingType.balance && period) {
    const mappedTerm = mapPublishTerm(period, service);

    terms.push(mappedTerm);
  }

  if (placingType === EPlacingType.package && servicePackage) {
    const mappedTerm = mapPublishTerm(servicePackage, service);

    terms.push(mappedTerm);
  }

  if (service.id === 'servicePackage' && recommendedPackage) {
    const mappedTerm = mapServicePackageTerm(recommendedPackage);

    terms.push(mappedTerm);
  }

  if (isAuctionEnabled && auction.currentBet && auction.periods[0]) {
    const mappedTerm = mapAuctionTerm({
      bet: auction.currentBet,
      period: auction.periods[0],
      services: auction.services,
    });

    terms.push(mappedTerm);
  }

  if (calltracking.isEnabled && calltracking.selectedPeriodId !== null) {
    const mappedTerm = mapCalltrackingTerm({
      period: calltracking.periods[calltracking.selectedPeriodId],
      services: calltracking.services,
    });

    terms.push(mappedTerm);
  }

  return terms;
}
